import Body from './Body';
const Stages = () => {
    return (
        <Body />
    )
}

export default Stages
